/*=====================================
    Cupoy Noteeditor Module and Directive

    Author: Gray
    CreateTime: 2019 / 03 / 07
=====================================*/
var cupoyDraftModule = angular.module('cupoy.draft', []);

cupoyDraftModule.directive('previewCupoyNoteEditor', ['$rootScope', function($rootScope) {

    var link = function(scope, element, attrs) {

        var notewidth = attrs.width;
        notewidth = isNaN(notewidth) ? undefined : Number(notewidth);

        scope.noteStyle = {
            zoom: '0.85',
        }

        if(notewidth) {
            scope.noteStyle.width = notewidth + 'px';
        }

        var clearWatch = scope.$watch('html', function(newValue, oldValue) {
            
            if(newValue) {
                var parser = new CupoyNoteHtmlParser(newValue);
                var result = parser.getResult().outerHTML;

                scope.result = result;
                // clearWatch();
            }
        });
    }

    /*--------------------------
            Export
        --------------------------*/
        return {
            restrict: 'E',
            link: link,
            replace: "true",
            template: '<div class="cupoydraft-content-style" ng-bind-html="result" ng-style="noteStyle"></div>',
            scope: {
                html: '=',
                width: '&'
            },
        };
}])